import React, { useEffect, useState } from "react";
import NorthIcon from '@mui/icons-material/North';
import './commonCssSheet.css';


const ScrollTopTab = () => {
  const [isVisible, setIsVisible] = useState(false);
  const goToBtn = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };
  const listenToScroll = () => {
    let heightToHidden = 400;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHidden) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };


  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center position-relative">
      {isVisible && (
        <div className="top-btn" onClick={goToBtn}>
          <NorthIcon />
        </div>
      )}
    </div>
  );
};



export default ScrollTopTab